import styled from 'styled-components/macro';
import { defaultContainer } from '../../styles/utils';
import { TabsDiv, TabNavLink } from '../../components/TabStyles';
import { HeaderBlockDiv } from '../../components/HeaderBlockStyles';

export const MarketingDiv = styled.div`
  ${defaultContainer}
  @media screen and (max-width: 767px) {
    ${HeaderBlockDiv} {
      margin-bottom: 3rem;
    }
  }
`;

export const HeaderBlockP = styled.p`
  margin-top: 15px;
  padding: 1.5rem 0;
`;

export const MarketingBodyDiv = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-content: flex-start;
  margin: 0 -10px;

  @media screen and (min-width: 768px) {
    justify-content: flex-start;
  }
`;

export const MarketingNavTabsDiv = styled.div`
  margin-bottom: 35px;
  @media screen and (max-width: 768px) {
    overflow-x: scroll;
    width: 100%;
  }
  ${TabsDiv} {
    padding-top: 0rem;
    margin-left: 0rem;
    @media screen and (min-width: 1024px) {
      margin-bottom: 4.5rem;
    }
  }
  ${TabNavLink} {
    @media screen and (max-width: 768px) {
      &:first-child {
        padding-left: 0rem;
      }
    }
    @media screen and (min-width: 768px) {
      padding: 0.8rem 3rem;
      &:first-child {
        padding-left: 0rem;
      }
    }
  }
`;

export const BorderDiv = styled.div`
  border-right: 1px solid ${props => props.theme.dustyGray};
  margin: 0px 15px;
`;

export const DownloadLinkA = styled.a`
  padding: 1rem;
  color: black;
  ${props => props.theme.fontStackHeader};
  height: 100%;
  &:hover {
    color: ${props => props.theme.blue};
  }
`;

export const DownloadLinkDesktopA = styled.a`
  color: black;
  /* padding: 0rem 1rem; */
  cursor: pointer;
  span:hover {
    text-decoration: underline;
  }
`;

export const SalesMaterialItemDiv = styled.div`
  margin-bottom: 5px;
  svg {
    fill: ${props => props.theme.blue};
    min-width: 10px;
    width: 10px;
    height: 10px;
    margin-right: 16px;
  }
  @media screen and (min-width: 1024px) {
    padding: 1rem;
    margin-bottom: 5px;
    span,
    ${BorderDiv} {
      display: none;
    }
    &:hover {
      span,
      ${BorderDiv} {
        display: inline-block;
      }
    }
  }
`;

export const FileNameLabel = styled.label`
  font-weight: 500;
  font-size: 14px;
  ${props => props.theme.fontStackHeader};
  cursor: pointer;
`;

export const SalesMaterialItemHeader = styled.div`
  display: flex;
  &:hover {
    ${FileNameLabel} {
      color: ${props => props.theme.blue};
    }
  }
`;

export const SalesMaterialDescription = styled.div`
  padding-left: calc(26px + 1rem);
  @media screen and (min-width: 1024px) {
    padding-left: 27px;
    margin-top: 5px;
  }
  p {
    max-width: 895px;
  }
`;
